module.exports = __webpack_public_path__ + "4e416af986aa63ad55cc2d5591772f98.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-24.png
// module id = 2914
// module chunks = 0